import { usePickUpInStoreConfirm } from '@bluheadless/ui-logic/src/hooks/store-locator/usePickUpInStoreConfirm'
import { useNotification } from '@bluheadless/ui-logic/src/hooks/useNotification'
import { string } from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'
import Button from '../../../molecules/button'
import Heading from '../../../molecules/heading'
import { Root } from './confirm.styled'

const ConfirmPageComponent = ({ hash }) => {
	const { formatMessage } = useIntl()
	const { action: confirm, loading } = usePickUpInStoreConfirm()
	const { enqueueNotification } = useNotification()

	const handleConfirm = async () => {
		try {
			await confirm({ hash })
			enqueueNotification({ uiProps: { message: formatMessage({ id: 'pick_up_in_store_confirm_success' }) } })
		} catch (err) {
			enqueueNotification({
				uiProps: {
					severity: 'error',
					message: formatMessage({ id: err?.response?.data?.error?.message ?? 'pick_up_in_store_confirm_error' }),
				},
			})
		}
	}

	return (
		<Root>
			<Heading
				title={<FormattedMessage id="pick_up_in_store_title" />}
				subtitle={<FormattedMessage id="pick_up_in_store_confirm" />}
			/>
			<Button
				variant="contained"
				color="primary"
				label={<FormattedMessage id="pick_up_in_store_confirm_btn" />}
				onClick={handleConfirm}
				disabled={loading}
				loading={loading}
			/>
		</Root>
	)
}

ConfirmPageComponent.defaultProps = {}
ConfirmPageComponent.propTypes = {
	hash: string.isRequired,
}

export default ConfirmPageComponent
